import { Box, Flex, IconButton, VStack, useDisclosure } from "@chakra-ui/react";

import { useDocumentTitle } from "@equidefi/portals/hooks/useDocumentTitle";
import { useCurrentUser } from "@equidefi/portals/hooks/useUsers";
import { Heading, Text } from "@equidefi/ui";
import { Icon } from "@equidefi/ui/icon";

import { VaultContainer, ProfileNavButton } from "@/pages/app/vault/v2/components";
import { ProfileModal } from "@/pages/app/vault/profile/ProfileModal";

const Profile = () => {
  useDocumentTitle(["Account"]);

  const profileModal = useDisclosure();
  const { data: me, refetch } = useCurrentUser();

  return (
    <>
      <VaultContainer>
        <VStack align="stretch" spacing="4" w="full">
          <Box
            bg="white"
            borderRadius="lg"
            p="4"
            boxShadow="0 1px 2px rgba(0, 0, 0, 0.2)"
            border="1px solid"
            borderColor="gray.100">
            <Flex justify="space-between" align="flex-start" gap="3">
              <Box>
                <Heading as="h1" fontSize="24px" lineHeight="28px" fontWeight="700" mb="2.5">
                  Account
                </Heading>

                <Text
                  mb="2.5"
                  fontSize="13px"
                  lineHeight="18px"
                  fontWeight="600"
                  color="#657797"
                  textTransform="uppercase">
                  EQUIDEFI INVESTOR ACCOUNT
                </Text>

                <Text m="0" fontSize="17px" lineHeight="26px">
                  {me?.email}
                </Text>

                <Text m="0" fontSize="17px" lineHeight="26px">
                  {me?.phone}
                </Text>
              </Box>

              <IconButton
                onClick={profileModal.onOpen}
                icon={<Icon.Edit size="1.25em" />}
                variant="ghost"
                aria-label="Edit profile"
                color="equidefi.blue"
                minW="auto"
                h="8"
                w="8"
              />
            </Flex>
          </Box>

          <ProfileNavButton to="/vault/profile/password">Change Password</ProfileNavButton>

          <ProfileNavButton to="/vault/profile/saved-profiles">Saved Profiles</ProfileNavButton>
        </VStack>
      </VaultContainer>

      <ProfileModal modal={profileModal} onSave={refetch} me={me} />
    </>
  );
};

export default Profile;
